<script lang="ts">
	import NotificationMenu from './NotificationMenu.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import { notifications } from '$lib/stores/notificationStore';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import Popover from '$lib/components/Popover/Popover.svelte';
	import NotificationSettings from './NotificationSettings.svelte';
	import { onDestroy, onMount } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;

	const { restApi } = getHubStores();

	let isSettingsActive = false;

	const setSettingsActive = () => {
		isSettingsActive = true;
	};
	const setSettingsNotActive = () => {
		isSettingsActive = false;
	};

	const fetchNotifications = async () => {
		try {
			let resp = await restApi.fetchNotifications($hub.id);
			if (resp.status === 200 && resp.data) {
				$notifications = resp.data;
			}
		} catch (err) {
			console.error(err);
		}
	};

	onMount(async () => {
		await fetchNotifications();
	});

	const everyMinute = 1000 * 60;
	const poller = setInterval(() => void fetchNotifications(), everyMinute);
	onDestroy(() => clearInterval(poller));

	let isOpen: boolean;
	let close = () => {
		isOpen = false;
	};
</script>

<Popover position="bottom-inline-start" bind:isOpen>
	<div slot="target" class="notificationIcon">
		<div>
			<Icon clickable icon="bell" size={'24'} color={$hub.theme.headerIconColor} />
		</div>
		{#if $notifications.length}
			<div class="notificationsIndicator">
				{$notifications.length}
			</div>
		{/if}
	</div>
	<div slot="content">
		{#if isSettingsActive}
			<NotificationSettings {setSettingsNotActive} {close} />
		{:else}
			<NotificationMenu {setSettingsActive} />
		{/if}
	</div>
</Popover>

<style>
	.notificationIcon {
		display: grid;
	}

	.notificationIcon > * {
		grid-column: 1;
		grid-row: 1;
		margin: auto;
	}

	.notificationsIndicator {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: 36px;
		inline-size: 36px;
		border: solid 2px white;
		border-radius: 50%;
		background: rgb(85 106 122 / 50%);
		color: white;
		cursor: pointer;
	}
</style>
